
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiKeepingArea as ObiKeepingAreaElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-keeping-area.js';
 
 
 

 
 export const ObiKeepingArea = createComponent({
   react: React,
   tagName: 'obi-keeping-area',
   elementClass: ObiKeepingAreaElement,
   events: {
     
   }
  });
 
 